<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.75 -0.75 24 24"
    height="24"
    width="24"
  >
    <defs></defs>
    <title>pencil-write</title>
    <path
      d="m12.2296875 13.2525 -3.48 0.49781250000000005 0.496875 -3.4809375 8.949375 -8.949375a2.109375 2.109375 0 0 1 2.983125 2.983125Z"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="m17.201249999999998 2.3146875 2.983125 2.983125"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
    <path
      d="M17.578125 13.359375v7.03125a1.40625 1.40625 0 0 1 -1.40625 1.40625h-14.0625a1.40625 1.40625 0 0 1 -1.40625 -1.40625v-14.0625a1.40625 1.40625 0 0 1 1.40625 -1.40625h7.03125"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></path>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>